import ForterCaptcha from "./forter-captcha";
import makeAsyncScriptLoader from "react-async-script";

const callbackName = "onloadcallback";
const globalName = "fcaptcha";

function getURL() {
  return `https://captcha.forter.com/api/fcaptcha_api.min.js?onload=${callbackName}&render=explicit`;
}

export default makeAsyncScriptLoader(getURL, {
  callbackName,
  globalName,
})(ForterCaptcha);